/* v3 collection — submit the sort control when the shopper changes it.

   The <form> works without this: it has a real action and a real submit
   button inside <noscript>, so with JavaScript off the control still sorts.
   All this does is remove the second click.

   Delegated from the document, like v3-nav.js, so it costs nothing on the
   pages that have no sort control and needs no per-page wiring. */
(function () {
  'use strict';
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-v3-sort]');
    if (!sel) return;
    var form = sel.form;
    if (!form) return;
    /* requestSubmit, not submit: it fires the form's submit event and honours
       validation, where form.submit() bypasses both. Older engines that lack it
       fall back. */
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });
}());
